import React, { useState } from "react";
import {
  StyledButton,
  StyledHCard,
  StyledHome,
  StyledTab,
} from "../components/Styles";
import { Link } from "react-router-dom";

import img10 from "../components/Styles/assets/img10.webp";
import img17 from "../components/Styles/assets/img23.webp";

import ExpertTeam from "../components/Styles/assets/Graphics/ExpertTeam.webp";
import CostEffectiveSolutuon from "../components/Styles/assets/Graphics/CostEffectiveSolutuon.webp";
import Deadline from "../components/Styles/assets/Graphics/Deadline.webp";
import Communication from "../components/Styles/assets/Graphics/Communication.webp";
import Creativity from "../components/Styles/assets/Graphics/Creativity.webp";
import Quality from "../components/Styles/assets/Graphics/Quality.webp";

import WebApplication from "../components/Styles/assets/Graphics/WebApplication.webp";
import MobileApplication from "../components/Styles/assets/Graphics/MobileApplication.webp";
import uiuxDesign from "../components/Styles/assets/Graphics/uiuxDesign.webp";
import Wordpress from "../components/Styles/assets/Graphics/WordPress2.webp";
import SEO from "../components/Styles/assets/Graphics/SEO.webp";
import SocialMedia from "../components/Styles/assets/Graphics/SocialMedia.webp";
import LocalSEO from "../components/Styles/assets/Graphics/LocalSEO.webp";

import Consultation from "../components/Consultation";
import TrueIcon from "../components/Icons/True";
import { useTranslation } from "react-i18next";

function Home() {
  const [activeTab, setActiveTab] = useState("webapp");
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const services = [
    { key: "webapp", icon: WebApplication, title: t("home.services.webapp") },
    { key: "mobapp", icon: MobileApplication, title: t("home.services.mobapp") },
    { key: "uiux", icon: uiuxDesign, title: t("home.services.uiux") },
    { key: "wordpress", icon: Wordpress, title: t("home.services.wordpress") },
    { key: "seo", icon: LocalSEO, title: t("home.services.seo") },
    { key: "social", icon: SocialMedia, title: t("home.services.social") },
  ];

  const features = [
    { icon: ExpertTeam, title: t("home.features.team.title"), desc: t("home.features.team.desc") },
    { icon: CostEffectiveSolutuon, title: t("home.features.cost.title"), desc: t("home.features.cost.desc") },
    { icon: Deadline, title: t("home.features.deadline.title"), desc: t("home.features.deadline.desc") },
    { icon: Communication, title: t("home.features.communication.title"), desc: t("home.features.communication.desc") },
    { icon: Creativity, title: t("home.features.creativity.title"), desc: t("home.features.creativity.desc") },
    { icon: Quality, title: t("home.features.quality.title"), desc: t("home.features.quality.desc") },
  ];

  return (
    <StyledHome.Container>
      <StyledHome.Landing>
        <div className="text">
          <p>{t("home.landing.subtitle")}</p>
          <h1>
            {t("home.landing.title")}
            <span>{t("home.landing.tagline")}</span>
          </h1>
          <p>{t("home.landing.description")}</p>
          <Link to="/about-us">
            <StyledButton.Main small>{t("home.landing.about")}</StyledButton.Main>
          </Link>
        </div>
      </StyledHome.Landing>

      <StyledHome.Hero>
        <StyledHome.Content>
          <StyledHome.Title>{t("home.hero.title")}</StyledHome.Title>
          <StyledHome.Description>
            {t("home.hero.description")}
            <ul>
              {["webapp", "mobapp", "uiux", "wordpress"].map((s) => (
                <li key={s}>
                  <TrueIcon color={"#caa037"} width={14} height={14} />
                  <span>{t(`home.hero.list.${s}`)}</span>
                </li>
              ))}
            </ul>
            {t("home.hero.conclusion")}
          </StyledHome.Description>
        </StyledHome.Content>
        <StyledHome.ImageContainer>
          <img src={img17} alt={t("home.hero.alt")} />
        </StyledHome.ImageContainer>
      </StyledHome.Hero>

      <Consultation />

      <StyledHome.H3 lang={i18n.language}>{t("home.servicesTitle")}</StyledHome.H3>
      <StyledTab.Container>
        <StyledTab.Nav>
          {services.map((s) => (
            <StyledTab.NavItem key={s.key}>
              <StyledTab.NavButton
                lang={i18n.language}
                isActive={activeTab === s.key}
                onClick={() => setActiveTab(s.key)}
              >
                <StyledTab.Icon>
                  <img src={s.icon} alt={s.title} />
                </StyledTab.Icon>
                {s.title}
              </StyledTab.NavButton>
            </StyledTab.NavItem>
          ))}
        </StyledTab.Nav>

        <StyledTab.TabContent lang={i18n.language}>
          {services.map((s) => (
            <StyledTab.TabPane key={s.key} isActive={activeTab === s.key} lang={i18n.language}>
              <h4>{t(`home.tab.${s.key}.title`)}</h4>
              <p>{t(`home.tab.${s.key}.desc`)}</p>
              {t(`home.tab.${s.key}.extra`) && <p>{t(`home.tab.${s.key}.extra`)}</p>}
            </StyledTab.TabPane>
          ))}
        </StyledTab.TabContent>
      </StyledTab.Container>

      <StyledHome.H3 lang={i18n.language}>{t("home.featuresTitle")}</StyledHome.H3>
      <StyledHCard.Container>
        {features.map((f, i) => (
          <StyledHCard.SingleCard key={i}>
            <StyledHCard.IconContainer>
              <img src={f.icon} alt={f.title} />
            </StyledHCard.IconContainer>
            <StyledHCard.Content>
              <StyledHCard.Title>{f.title}</StyledHCard.Title>
              <StyledHCard.Description>{f.desc}</StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledHome.Container>
  );
}

export default Home;